import type { MessageKey } from "./en";

// TODO:i18n — machine-translated placeholders, review with native speaker.
export const hi: Partial<Record<MessageKey, string>> = {
  "nav.home": "होम",
  "nav.repos": "रिपॉजिटरी",
  "nav.issues": "शुरुआती कार्य",
  "nav.developers": "डेवलपर",
  "nav.submit": "अपना प्रोजेक्ट जमा करें",

  "common.loading": "लोड हो रहा है…",
  "common.error": "कुछ गलत हो गया",
  "common.retry": "पुनः प्रयास करें",
  "common.search": "खोजें",

  "hero.title": "कुबेरकॉइन ओपन सोर्स प्लेटफ़ॉर्म",
  "hero.subtitle":
    "कुबेरकॉइन पारिस्थितिकी तंत्र में ओपन-सोर्स परियोजनाओं की खोज करें, योगदान दें और वित्त पोषण करें।",
  "hero.cta_browse": "परियोजनाएँ ब्राउज़ करें",
  "hero.cta_submit": "अपना प्रोजेक्ट जमा करें",

  "repos.stars": "स्टार",
  "repos.forks": "फ़ोर्क",
  "repos.language": "भाषा",

  "footer.copyright": "© 2026 कुबेरकॉइन ओपन सोर्स",
  "footer.license": "MIT लाइसेंस के तहत जारी।",

  "nav.playground": "प्लेग्राउंड",
  "nav.changelog": "बदलाव लॉग",
  "nav.apiDocs": "API दस्तावेज़",
  "nav.contributors": "योगदानकर्ता",
  "nav.devLogin": "डेव लॉगिन",
  "nav.admin": "एडमिन",
  "nav.logout": "लॉग आउट",

  "search.title": "खोजें",
  "search.placeholder": "रेपो, फ़ाइलें, सबमिशन खोजें…",
  "search.button": "खोजें",
  "search.filter.all": "सभी",
  "search.filter.repos": "रेपो",
  "search.filter.files": "फ़ाइलें",
  "search.filter.submissions": "सबमिशन",
  "search.type.repository": "रिपॉजिटरी",
  "search.type.file": "फ़ाइल",
  "search.type.submission": "सबमिशन",
  "search.empty": "कोई परिणाम नहीं मिला। कोई अन्य शब्द आज़माएँ।",

  "notifications.title": "सूचनाएँ",
  "notifications.markAllRead": "सभी पढ़ा हुआ चिह्नित करें",
  "notifications.markRead": "पढ़ा हुआ चिह्नित करें",
  "notifications.empty": "अभी तक कोई सूचना नहीं।",

  "contributors.title": "योगदानकर्ता",
  "contributors.subtitle":
    "KuberCoin के ओपन-सोर्स पारिस्थितिकी तंत्र बनाने वाले डेवलपर्स से मिलें।",
  "contributors.searchPlaceholder": "योगदानकर्ता खोजें…",
  "contributors.sort.activity": "सबसे सक्रिय",
  "contributors.sort.newest": "नवीनतम",
  "contributors.sort.oldest": "सबसे पुराने",
  "contributors.sort.name": "नाम A–Z",
  "contributors.emptySearch": "आपकी खोज से कोई योगदानकर्ता मेल नहीं खाता।",
  "contributors.empty": "अभी तक कोई योगदानकर्ता नहीं।",

  "pagination.previous": "पिछला",
  "pagination.next": "अगला",

  "rateLimit.slowDown": "अनुरोध सीमा पार — कृपया धीमा करें",

  "notFound.title": "पृष्ठ नहीं मिला",
  "notFound.message":
    "आप जिस पृष्ठ की तलाश कर रहे हैं वह मौजूद नहीं है या स्थानांतरित कर दिया गया है।",
  "notFound.home": "होम पर वापस जाएँ",

  "settings.title": "सेटिंग्स",
  "settings.theme": "थीम",
  "settings.themeDescription": "अपनी पसंदीदा रंग थीम चुनें।",
  "settings.switchToLight": "लाइट पर स्विच करें",
  "settings.switchToDark": "डार्क पर स्विच करें",
  "settings.language": "भाषा",
  "settings.languageDescription": "अपनी पसंदीदा भाषा चुनें।",
  "settings.notifications": "सूचनाएँ",
  "settings.emailNotifications": "ईमेल सूचनाएँ",

  // --- Session ---
  "session.expired": "आपका सत्र समाप्त हो गया है। कृपया फिर से साइन इन करें।",

  // --- Offline ---
  "offline.banner": "आप ऑफ़लाइन हैं। कुछ सुविधाएँ अनुपलब्ध हो सकती हैं।",

  // --- Shortcuts ---
  "shortcuts.title": "कीबोर्ड शॉर्टकट",
  "shortcuts.hint": "इस डायलॉग को खोलने/बंद करने के लिए ? दबाएँ",

  "activity.title": "गतिविधि फ़ीड",
  "activity.subtitle": "KuberCoin ओपन-सोर्स पारिस्थितिकी में हाल की गतिविधि।",
  "activity.empty": "कोई हाल की गतिविधि नहीं।",

  "issues.title": "शुरुआती कार्य",
  "issues.subtitle": "योगदान शुरू करने के लिए शुरुआती-अनुकूल कार्य खोजें।",
  "issues.empty": "इस समय कोई खुले कार्य नहीं।",
  "issues.difficulty.all": "सभी",
  "issues.difficulty.beginner": "शुरुआती",
  "issues.difficulty.intermediate": "मध्यवर्ती",
  "issues.viewRepo": "रिपो देखें",

  "apiDocs.title": "API दस्तावेज़ीकरण",
  "apiDocs.subtitle": "KuberCoin ओपन API विनिर्देश एक्सप्लोर करें।",
  "apiDocs.loading": "API विनिर्देश लोड हो रहा है…",
  "apiDocs.error": "API विनिर्देश लोड करने में विफल।",

  "time.justNow": "अभी",
  "time.minutesAgo": "{n}मि॰ पहले",
  "time.hoursAgo": "{n}घं॰ पहले",
  "time.daysAgo": "{n}दि॰ पहले",

  "empty.generic": "यहाँ अभी कुछ नहीं।",
  "empty.noResults": "कोई परिणाम नहीं मिला।",
};
